import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 lg:py-32 bg-ucensys-navy relative" data-id="element-138">
      <div className="absolute inset-0 bg-dot-pattern opacity-20 pointer-events-none" data-id="element-139"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-140">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-141">
          {/* Form Side */}
          <div className="bg-ucensys-card border border-border-color rounded-2xl p-8 md:p-10 shadow-xl" data-id="element-142">
            <h2 className="text-3xl font-heading font-bold text-white mb-2" data-id="element-143">
              Let's Build Your Infrastructure
            </h2>
            <p className="text-text-secondary font-body mb-8" data-id="element-144">
              Fill out the form below and our engineering team will be in touch
              shortly.
            </p>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-145">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-146">
                <div className="space-y-2" data-id="element-147">
                  <label htmlFor="name" className="text-sm font-body font-medium text-text-secondary" data-id="element-148">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full bg-ucensys-navy border border-border-color rounded-lg px-4 py-3 text-white focus:outline-none focus:border-ucensys-teal transition-colors" placeholder="John Doe" data-id="element-149" />
                </div>
                <div className="space-y-2" data-id="element-150">
                  <label htmlFor="company" className="text-sm font-body font-medium text-text-secondary" data-id="element-151">
                    Company
                  </label>
                  <input type="text" id="company" className="w-full bg-ucensys-navy border border-border-color rounded-lg px-4 py-3 text-white focus:outline-none focus:border-ucensys-teal transition-colors" placeholder="Acme Corp" data-id="element-152" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-153">
                <div className="space-y-2" data-id="element-154">
                  <label htmlFor="email" className="text-sm font-body font-medium text-text-secondary" data-id="element-155">
                    Work Email
                  </label>
                  <input type="email" id="email" className="w-full bg-ucensys-navy border border-border-color rounded-lg px-4 py-3 text-white focus:outline-none focus:border-ucensys-teal transition-colors" placeholder="john@company.com" data-id="element-156" />
                </div>
                <div className="space-y-2" data-id="element-157">
                  <label htmlFor="phone" className="text-sm font-body font-medium text-text-secondary" data-id="element-158">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full bg-ucensys-navy border border-border-color rounded-lg px-4 py-3 text-white focus:outline-none focus:border-ucensys-teal transition-colors" placeholder="+1 (555) 000-0000" data-id="element-159" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-160">
                <label htmlFor="interest" className="text-sm font-body font-medium text-text-secondary" data-id="element-161">
                  What are you looking for?
                </label>
                <select id="interest" className="w-full bg-ucensys-navy border border-border-color rounded-lg px-4 py-3 text-white focus:outline-none focus:border-ucensys-teal transition-colors appearance-none" data-id="element-162">
                  <option value="" data-id="element-163">Select an option...</option>
                  <option value="colocation" data-id="element-164">Colocation Services</option>
                  <option value="managed" data-id="element-165">Managed Cloud</option>
                  <option value="ai" data-id="element-166">AI/ML Infrastructure</option>
                  <option value="consulting" data-id="element-167">Consulting</option>
                  <option value="tour" data-id="element-168">Tour Request</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-169">
                <label htmlFor="message" className="text-sm font-body font-medium text-text-secondary" data-id="element-170">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full bg-ucensys-navy border border-border-color rounded-lg px-4 py-3 text-white focus:outline-none focus:border-ucensys-teal transition-colors resize-none" placeholder="Tell us about your infrastructure needs..." data-id="element-171"></textarea>
              </div>

              <button type="submit" className="w-full bg-teal-gradient text-white font-heading font-semibold px-8 py-4 rounded-xl hover:shadow-teal-glow transition-all duration-300 flex items-center justify-center gap-2" data-id="element-172">
                Send Inquiry <ArrowRightIcon className="w-5 h-5" data-id="element-173" />
              </button>
            </form>
          </div>

          {/* Info Side */}
          <div className="flex flex-col justify-center" data-id="element-174">
            <div className="mb-12" data-id="element-175">
              <h3 className="text-2xl font-heading font-bold text-white mb-6" data-id="element-176">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-177">
                <div className="flex items-start gap-4" data-id="element-178">
                  <div className="w-10 h-10 rounded-full bg-ucensys-card border border-border-color flex items-center justify-center text-ucensys-teal flex-shrink-0" data-id="element-179">
                    <MapPinIcon className="w-5 h-5" data-id="element-180" />
                  </div>
                  <div data-id="element-181">
                    <h4 className="text-white font-heading font-semibold mb-1" data-id="element-182">
                      Headquarters & Data Center
                    </h4>
                    <p className="text-text-secondary font-body text-sm leading-relaxed" data-id="element-183">
                      Historic Truist Bank Building
                      <br data-id="element-184" />
                      Downtown Atlanta Financial District
                      <br data-id="element-185" />
                      Atlanta, GA
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-186">
                  <div className="w-10 h-10 rounded-full bg-ucensys-card border border-border-color flex items-center justify-center text-ucensys-teal flex-shrink-0" data-id="element-187">
                    <PhoneIcon className="w-5 h-5" data-id="element-188" />
                  </div>
                  <div data-id="element-189">
                    <h4 className="text-white font-heading font-semibold mb-1" data-id="element-190">
                      Phone
                    </h4>
                    <p className="text-text-secondary font-body text-sm" data-id="element-191">
                      +1 (800) 555-0199
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-192">
                  <div className="w-10 h-10 rounded-full bg-ucensys-card border border-border-color flex items-center justify-center text-ucensys-teal flex-shrink-0" data-id="element-193">
                    <MailIcon className="w-5 h-5" data-id="element-194" />
                  </div>
                  <div data-id="element-195">
                    <h4 className="text-white font-heading font-semibold mb-1" data-id="element-196">
                      Email
                    </h4>
                    <p className="text-text-secondary font-body text-sm" data-id="element-197">
                      info@ucensys.com
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-ucensys-teal/20 to-ucensys-navy border border-ucensys-teal/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-198">
              <div className="absolute top-0 right-0 w-32 h-32 bg-ucensys-teal/10 blur-2xl rounded-full" data-id="element-199"></div>
              <h3 className="text-xl font-heading font-bold text-white mb-2 relative z-10" data-id="element-200">
                Schedule a Data Center Tour
              </h3>
              <p className="text-text-secondary font-body text-sm mb-6 relative z-10" data-id="element-201">
                See our enterprise-grade infrastructure and security protocols
                firsthand. Tours are available for qualified enterprise
                prospects.
              </p>
              <button className="px-6 py-3 rounded-full border border-ucensys-teal text-ucensys-teal font-heading font-semibold hover:bg-ucensys-teal hover:text-white transition-all duration-300 text-sm relative z-10" data-id="element-202">
                Request a Tour
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}